import { render, staticRenderFns } from "./EnReceptionRobot.vue?vue&type=template&id=85f3f504&scoped=true"
import script from "./EnReceptionRobot.vue?vue&type=script&lang=js"
export * from "./EnReceptionRobot.vue?vue&type=script&lang=js"
import style0 from "./EnReceptionRobot.vue?vue&type=style&index=0&id=85f3f504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f3f504",
  null
  
)

export default component.exports